import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';
import moment from 'moment';

import selectors from '../../store/selectors';

const fetchDevotions = (accountId, dateTo, devotionType) => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/masses?${new URLSearchParams({
    from: moment().format('YYYY-MM-DD'),
    to: dateTo,
    devotionType,
  }).toString()}`,
});

export const useFetchDevotions = devotionType => {
  const accountId = useSelector(selectors.getAccountId);
  const massOfferingMassRequestToDate = useSelector(selectors.getMassOfferingMassRequestToDate);

  const { payload, loading, error, query } = useQuery(
    fetchDevotions(accountId, massOfferingMassRequestToDate, devotionType),
  );

  // Sort payload by massDate if it exists
  const sortedPayload = payload
    ? [...payload].sort((a, b) => moment(a.massDate).diff(moment(b.massDate)))
    : [];

  return {
    payload: sortedPayload,
    loading,
    error,
    refetch: query,
  };
};
